module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-BoldItalic.42a627c.woff2";